import {halClientOptions} from 'hal-client';
import store from '@/store/store';
import { Auth } from 'aws-amplify';

if (store.state.account.accessToken) {
  halClientOptions.headers.set('Authorization', store.state.account.accessToken);
}

halClientOptions.interceptors.$beforeRequest = async () => {
  if (!store.state.account.accessToken) {
    return;
  }
  try {
    const session = await Auth.currentSession();
    if (halClientOptions.headers.get('Authorization') !== session.getAccessToken().jwtToken) {
      halClientOptions.headers.set('Authorization', session.getAccessToken().jwtToken);
      store.commit('account/setAccessToken', session.getAccessToken().jwtToken);
    }
  } catch {
    localStorage.removeItem('customer_access_token');
  }

};

halClientOptions.interceptors.$afterRequest = function (status) {
  if (status === 401 && store.state.account.accessToken) {
    store.commit('account/removeAccessToken');
    halClientOptions.headers.set('Authorization', null);
    location.reload();
  }
};

